import * as React from 'react'

const CheckMarker = (props: any) => (
  <svg {...props} viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M10 0L3.41023 7L0 2.91652' transform='translate(1 1)' stroke='#37C47E' strokeWidth='2' />
  </svg>
)

export default CheckMarker



// WEBPACK FOOTER //
// ./src/components/icons/ui/CheckMarker.tsx